import { Announcement03Icon } from "@/components/Icons/Announcement03Icon";
import { Asterisk01Icon } from "@/components/Icons/Asterisk01Icon";
import { BatteryMidIcon } from "@/components/Icons/BatteryMidIcon";
import { BellRinging04Icon } from "@/components/Icons/BellRinging04Icon";
import { BicycleIcon } from "@/components/Icons/BicycleIcon";
import { BookOpen01Icon } from "@/components/Icons/BookOpen01Icon";
import { Building01Icon } from "@/components/Icons/Building01Icon";
import { Building02Icon } from "@/components/Icons/Building02Icon";
import { Car01Icon } from "@/components/Icons/Car01Icon";
import { CarrotIcon } from "@/components/Icons/CarrotIcon";
import { CoffeeIcon } from "@/components/Icons/CoffeeIcon";
import { Compass01Icon } from "@/components/Icons/Compass01Icon";
import { CursorClick02Icon } from "@/components/Icons/CursorClick02Icon";
import { Dice6Icon } from "@/components/Icons/Dice6Icon";
import { DogIcon } from "@/components/Icons/DogIcon";
import { FaceHappyIcon } from "@/components/Icons/FaceHappyIcon";
import { FactoryIcon } from "@/components/Icons/FactoryIcon";
import { ForkAndKnifeIcon } from "@/components/Icons/ForkAndKnifeIcon";
import { GamingPad01Icon } from "@/components/Icons/GamingPad01Icon";
import { Gift02Icon } from "@/components/Icons/Gift02Icon";
import { HandshakeIcon } from "@/components/Icons/HandshakeIcon";
import { ImageUserCheckIcon } from "@/components/Icons/ImageUserCheckIcon";
import { Lightbulb04Icon } from "@/components/Icons/Lightbulb04Icon";
import { MailboxIcon } from "@/components/Icons/MailboxIcon";
import { Map01Icon } from "@/components/Icons/Map01Icon";
import { MarkerPin06Icon } from "@/components/Icons/MarkerPin06Icon";
import { MedicalSquareIcon } from "@/components/Icons/MedicalSquareIcon";
import { MessageChatSquareIcon } from "@/components/Icons/MessageChatSquareIcon";
import { MessageDotsSquareIcon } from "@/components/Icons/MessageDotsSquareIcon";
import { MusicNote01Icon } from "@/components/Icons/MusicNote01Icon";
import { NetworkIcon } from "@/components/Icons/NetworkIcon";
import { PackageIcon } from "@/components/Icons/PackageIcon";
import { PlantIcon } from "@/components/Icons/PlantIcon";
import { SearchSmIcon } from "@/components/Icons/SearchSmIcon";
import { ShoppingCart01Icon } from "@/components/Icons/ShoppingCart01Icon";
import { SportIcon } from "@/components/Icons/SportIcon";
import { Target01Icon } from "@/components/Icons/Target01Icon";
import { Tool02Icon } from "@/components/Icons/Tool02Icon";
import { Users03Icon } from "@/components/Icons/Users03Icon";
import { WifiIcon } from "@/components/Icons/WifiIcon";
import { WineGlassIcon } from "@/components/Icons/WineGlassIcon";

export type GroupIconType =
  | "announcement"
  | "asterisk"
  | "batteryMid"
  | "bellRinging"
  | "bicycle"
  | "bookOpen"
  | "building01"
  | "building02"
  | "car"
  | "carrot"
  | "coffee"
  | "compass"
  | "cursorClick"
  | "dice"
  | "dog"
  | "faceHappy"
  | "factory"
  | "forkAndKnife"
  | "gamingPad"
  | "gift"
  | "handshake"
  | "imageUserCheck"
  | "lightBulb"
  | "mailbox"
  | "map"
  | "markerPin"
  | "medicalSquare"
  | "messageChatSquare"
  | "messageDotsSquare"
  | "musicNote"
  | "network"
  | "package"
  | "plant"
  | "search"
  | "shoppingCart"
  | "sport"
  | "target"
  | "tool"
  | "users"
  | "wifi"
  | "wineGlass";
interface GroupIconProps {
  icon: GroupIconType;
  size?: number;
  className?: string;
}
function getIcon(icon: GroupIconType, size?: number): React.ReactNode {
  switch (icon) {
    case "announcement":
      return <Announcement03Icon size={size} />;
    case "asterisk":
      return <Asterisk01Icon size={size} />;
    case "batteryMid":
      return <BatteryMidIcon size={size} />;
    case "bellRinging":
      return <BellRinging04Icon size={size} />;
    case "bicycle":
      return <BicycleIcon size={size} />;
    case "bookOpen":
      return <BookOpen01Icon size={size} />;
    case "building01":
      return <Building01Icon size={size} />;
    case "building02":
      return <Building02Icon size={size} />;
    case "car":
      return <Car01Icon size={size} />;
    case "carrot":
      return <CarrotIcon size={size} />;
    case "coffee":
      return <CoffeeIcon size={size} />;
    case "compass":
      return <Compass01Icon size={size} />;
    case "cursorClick":
      return <CursorClick02Icon size={size} />;
    case "dice":
      return <Dice6Icon size={size} />;
    case "dog":
      return <DogIcon size={size} />;
    case "faceHappy":
      return <FaceHappyIcon size={size} />;
    case "factory":
      return <FactoryIcon size={size} />;
    case "forkAndKnife":
      return <ForkAndKnifeIcon size={size} />;
    case "gamingPad":
      return <GamingPad01Icon size={size} />;
    case "gift":
      return <Gift02Icon size={size} />;
    case "handshake":
      return <HandshakeIcon size={size} />;
    case "imageUserCheck":
      return <ImageUserCheckIcon size={size} />;
    case "lightBulb":
      return <Lightbulb04Icon size={size} />;
    case "mailbox":
      return <MailboxIcon size={size} />;
    case "map":
      return <Map01Icon size={size} />;
    case "markerPin":
      return <MarkerPin06Icon size={size} />;
    case "medicalSquare":
      return <MedicalSquareIcon size={size} />;
    case "messageChatSquare":
      return <MessageChatSquareIcon size={size} />;
    case "messageDotsSquare":
      return <MessageDotsSquareIcon size={size} />;
    case "musicNote":
      return <MusicNote01Icon size={size} />;
    case "network":
      return <NetworkIcon size={size} />;
    case "package":
      return <PackageIcon size={size} />;
    case "plant":
      return <PlantIcon size={size} />;
    case "search":
      return <SearchSmIcon size={size} />;
    case "shoppingCart":
      return <ShoppingCart01Icon size={size} />;
    case "sport":
      return <SportIcon size={size} />;
    case "target":
      return <Target01Icon size={size} />;
    case "tool":
      return <Tool02Icon size={size} />;
    case "users":
      return <Users03Icon size={size} />;
    case "wifi":
      return <WifiIcon size={size} />;
    case "wineGlass":
      return <WineGlassIcon size={size} />;
  }
}
export function GroupIcon({ icon, size, className }: GroupIconProps): React.ReactNode {
  return <div className={className}>{getIcon(icon, size)}</div>;
}
export const GROUP_ICONS: GroupIconType[] = [
  "announcement",
  "asterisk",
  "batteryMid",
  "bellRinging",
  "bicycle",
  "bookOpen",
  "building01",
  "building02",
  "car",
  "carrot",
  "coffee",
  "compass",
  "cursorClick",
  "dice",
  "dog",
  "faceHappy",
  "factory",
  "forkAndKnife",
  "gamingPad",
  "gift",
  "handshake",
  "imageUserCheck",
  "lightBulb",
  "mailbox",
  "map",
  "markerPin",
  "medicalSquare",
  "messageChatSquare",
  "messageDotsSquare",
  "musicNote",
  "network",
  "package",
  "plant",
  "search",
  "shoppingCart",
  "sport",
  "target",
  "tool",
  "users",
  "wifi",
  "wineGlass",
];
